import { RESET_PASSWORD, SET_PASSWORD } from '../configs/routes';
import api from './api';

export const resetPassword = (data) =>
    new Promise((resolve, reject) => {
        api.post(RESET_PASSWORD, data)
            .then((response) => resolve(response.data))
            .catch((err) => {
                reject(
                    err.response?.data?.errors?.non_field_errors?.[0] ||
                        err.response?.data?.message ||
                        'Something went wrong',
                );
            });
    });

export const setPassword = (data) =>
    new Promise((resolve, reject) => {
        api.post(SET_PASSWORD, data)
            .then((response) => resolve(response.data))
            .catch((err) => {
                reject(
                    err.response?.data?.errors?.non_field_errors?.[0] ||
                        err.response?.data?.message ||
                        'Something went wrong',
                );
            });
    });
